export class Category {
    id: number = 0;
    category: string = '';
}

export class Type {
    id: number = 0;
    type: string = '';
    isGlobal: boolean = false;
}

export class Software {
    id: number = 0;
    profileId: number = 0;
    softwareTypeId: number = 0;
    softwareType: string = '';
    softwareCategoryId: number = 0;
    softwareCategory: string = '';
    name: string = '';
    version: string = '';
    formats: string = '';
}

export class SoftwareFilter {
    softwareId: number = 0;
    softwareCategoryId: number = 0;
    softwareTypeId: number = 0;
    softwareType: string = '';

    take: number = 0;
	skip: number = 0;
	orderBy: string = "id";
	orderByDescending: boolean = false;
}